import { useContext } from "react";
import { useQuery } from "react-query";
import AppContext from "../appContext";
import * as api from "../services";

export const initUserSettings = {
  clientStats: {
    N_left_personal: 50,
  },
  settings: {
    firstName: "",
    lastName: "",
    address: "", // city
    code: "", // practitioner code (no @)
    email: "", // login email
    email2: "", // Correspondence email
    testDeviceConnectionId: 0, // my device
    makePublic: 0, // search by code
    findOnName: 0, // search by name
    mailOnAdded: 0, // notify me by mail when I'm added as a practitioner
    mailOnNews: 0,
    mailOnResearch: 0,
    doOnDashboardLoad: "", // welcomeWithTest: show the modal to pair your phone
    email2Verified: 1,
    moodBoardLibrarySave: false, // show inport/export button in UserBoards
    disableContextSubscription: false,
    disablePublicLibrary: false,
    disableDashboardSelection: false,
    logoURL: `${window.REACT_APP_IMAGE_PATH}/logo-horizontal.png`,
    disableProjects: false,
    lang: "en",
  },
};

export default function useAccountSettings(props) {
  const { app } = useContext(AppContext);
  const sessionId = app?.sessionId ?? props?.sessionId ?? null;
  const projectId = props?.projectId ?? 0;
  const { data, isLoading, isError, refetch } = useQuery(
    ["settings", projectId, sessionId],
    () =>
      api.getUserSettings({ projectId, sessionId }).then((data) => ({
        clientStats: { ...initUserSettings.clientStats, ...data.clientStats },
        settings: { ...initUserSettings.settings, ...data.settings },
        jsLastUpdate: data?.jsLastUpdate ?? "",
      })),
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 1000 * 60 * 60 * 24,
      cacheTime: Infinity,
      placeholderData: () => initUserSettings,
      enabled: sessionId !== null,
    }
  );

  return {
    jsLastUpdate: data.jsLastUpdate,
    clientStats: data.clientStats,
    accountSettings: data.settings,
    isLoading,
    isError,
    refetchSettings: refetch,
  };
}
